module.exports = __webpack_public_path__ + "static/media/reference-slider-28.86ca6b4b.jpg";